import getLocalString from "constants/Localization";
import { useUpdateDailyFormWorkOrderMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateDailyFormWorkOrder() {
  const [mutation, { loading, data, error }] = useUpdateDailyFormWorkOrderMutation({
    refetchQueries: [
      "customGetDailyFormWorkOrders",
      "customGetVehicleDailyFormWorkOrders",
      "customGetDailyFormWorkOrder",
    ],
  });

  const [updateDailyFormWorkOrder, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateDailyFormWorkOrder",
    },
    {
      successMessage: getLocalString("fleet.update-work-order-success"),
      failureMessage: getLocalString("fleet.update-work-order-failure"),
    }
  );

  return [updateDailyFormWorkOrder, context] as const;
}
